module.exports = __webpack_public_path__ + "assets/50f5ef03e8cded00dc320d34d8c6009c.png";